import { useStore } from './globalStore'
import { getLocale } from './localeUtils'

export const getLocaleMarket = () => {
  const locale = getLocale()
  const selector = state => (locale == 'de' ? state?.marketDe : state?.marketAt)

  let myMarket = useStore(selector)

  return myMarket
}
